module.exports = __webpack_public_path__ + "static/img/proceeding.2222851.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/proceeding.png
// module id = WLfF
// module chunks = 4